module.exports = __webpack_public_path__ + "static/media/95381-qrcode.ec353266.gif";